import { handleBonusNotificationInfo } from '@core/js/components/system/App/hooks/usePushNotifier/common/handleBonusNotificationInfo';
/* Sportium changes - add dispatch */
export const bonusNoConfirmationNotificationInfo = async (
    { actionInfo, actionId },
    { lang, syncClose, dispatch }
) => handleBonusNotificationInfo(
    { actionInfo, actionId, isConfirmation: false },
    { lang, syncClose, dispatch }
);
